import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { TippyDirective } from '@ngneat/helipopper';
import { iApplyFormControl, isControlWithToolTip } from 'app/shared/model';

@Component({
    selector: 'tooltip',
    template: `
        @if (tooltip) {
            <mat-icon #tooltipIcon [svgIcon]="'mat_outline:help'" class="iapply-tooltip icon-size-4" [color]="'text-white'" [tp]="popper"></mat-icon>
            <ng-template #popper let-hide><span class="text-sm" [innerHtml]="tooltip"></span></ng-template>
        }
    `,
    imports: [
        CommonModule,
        MatIconModule,
        TippyDirective,
    ]
})
export class TooltipComponent implements OnInit, AfterViewInit
{
    @ViewChild('tooltipIcon') private tooltipIcon: MatIcon;

    /** @Input control: Setting the control input will override the title text, unless the control has no tooltip. */
    @Input() control: iApplyFormControl;

    /** @Input title: This will be used as defalt tooltip if control is not specified, or has no tooltip. */
    @Input() title: string = '';

    @Input() color: string = 'text-primary';

    tooltip: string = '';

    ngOnInit(): void {
        this.tooltip = isControlWithToolTip(this.control)
            ? this.control.tooltip
            : this.title;
    }

    ngAfterViewInit(): void {
        if (this.color) {
            this.tooltipIcon?._elementRef.nativeElement.classList.add(this.color);
        }
    }
}
